import { render, staticRenderFns } from "./HeaderAccountGlobal.vue?vue&type=template&id=03c1b4e2&"
import script from "./HeaderAccountGlobal.vue?vue&type=script&lang=js&"
export * from "./HeaderAccountGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeaderAccountGlobal.vue"
export default component.exports